import React from 'react';

import { prepareSearchUrl } from '../utils';

type EntityInfoBoxLinkRichItemProps = {
    label: string;
    links: string[];
    addColonMark?: boolean;
    className?: string;
    openInNewTab: boolean;
    encryptionDetails?: EncryptionDetailsType;
    containerType: 'span' | 'div';
};
export default function WikiBoxInfoBoxLinkRichItem({
    label,
    links,
    addColonMark,
    className = '',
    openInNewTab,
    encryptionDetails,
    containerType = 'span',
}): React.ReactElement<EntityInfoBoxLinkRichItemProps> {
    const parseLinks = (text, links, addColonMark = false) => {
        const replacer = (match, p1, p2) => {
            if (!links[p1]) {
                return p2;
            }
            return `<a href=${prepareSearchUrl(
                p2,
                links[p1],
                encryptionDetails,
            )} class="wikiBox__value-link" datatype="link" rel="noopener noreferrer" target=${
                openInNewTab ? '_blank' : ''
            }>${p2}</a>`;
        };
        return (
            text
                .replace(/(<([^>]+)>)/gi, '')
                .replace(/&nbsp;/gi, ' ')
                .replace(/\[\[(\d+):(.+?)\]\]/g, replacer)
                .replaceAll(', ,', ', ')
                .trim() + (addColonMark ? ': ' : '')
        );
    };

    if (!label) {
        return <span className={className}></span>;
    }

    if (containerType === 'span') {
        return (
            <span
                datatype={links?.length > 0 ? undefined : 'text'}
                className={className}
                dangerouslySetInnerHTML={{
                    __html: parseLinks(label, links, addColonMark),
                }}
            ></span>
        );
    }

    if (containerType === 'div') {
        return (
            <div
                datatype={links?.length > 0 ? undefined : 'text'}
                className={className}
                dangerouslySetInnerHTML={{
                    __html: parseLinks(label, links, addColonMark),
                }}
            ></div>
        );
    }
}
